import * as React from 'react'
import Head from 'next/head'

import { Meta } from '~/components'
import useVendor from '~/hooks/use-vendor'
import { jsonLdScriptProps } from '~/lib/json-ld-script-props'
import HomeScreen from '~/screens/home'
import getMetaInfo, { GetMetaInfoResult } from '~/utils/get-meta-info'
import { createWebPageSchema, createWebSiteSchema } from '~/utils/get-schemas'

interface HomePageProps {
  metaInfo: GetMetaInfoResult
}

function HomePage(props: HomePageProps) {
  const { metaInfo } = props

  const vendor = useVendor()

  const webPageSchema = createWebPageSchema(vendor, '/')

  const websiteSchema = createWebSiteSchema(vendor)

  return (
    <>
      <Head>
        <script {...jsonLdScriptProps(webPageSchema)} />
        <script {...jsonLdScriptProps(websiteSchema)} />
      </Head>
      <Meta {...metaInfo} />
      <HomeScreen />
    </>
  )
}

HomePage.getInitialProps = (context: PageContext): HomePageProps => {
  return {
    metaInfo: getMetaInfo(context),
  }
}

export default HomePage
